<template>
  <div id='codeList' align="left" style="margin-top:10px">

    <div class="mainDiv">
      <el-form ref="queryCondition" :model="queryCondition">
        <el-row :gutter="24">
          <el-col :span="6">
            代码类别名称
            <el-input size="mini" v-model="queryCondition.type" clearable placeholder="请输入内容" class="dialogDataWidth"
                      style="width: 50%;"></el-input>
          </el-col>
          <el-col :span="6">
            是否可用
            <el-select v-model="queryCondition.flag" placeholder="请选择" class="dialogDataWidth" size="mini">
              <el-option v-for="item in options_flag" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" plain size="small" @click='codeAdd' icon="el-icon-plus">新增</el-button>
            <el-button type="primary" plain size="small" @click='query' icon="el-icon-search">查询</el-button>
            <!-- <el-button type="primary" plain size="small" @click='reset' icon="el-icon-refresh">重置</el-button> -->
          </el-col>
        </el-row>
      </el-form>
      <el-table class="el-table" stripe size="mini" :data="pagedata.content" align="center" style="margin-top: 10px;"
                header-row-class-name="tableHeader">
        <el-table-column align='center' prop="id" type="index" label="序号" width=""
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column align='center' prop="name" label="代码类别名称" width=""
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column align='center' prop="type" label="代码类别" width=""
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column align='center' prop="code" label="代码值" width=""
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column align='center' prop="value" label="代码名称" width=""
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column align='center' prop="flag" label="代码状态" width="" :formatter="farmatterFlag"
                         label-class-name="greenLabel"></el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-tooltip content="查看" placement="top" effect="light">
              <el-button @click="codeView(scope.row)" icon="el-icon-zoom-in" size="small"></el-button>
            </el-tooltip>
            <el-tooltip content="编辑" placement="top" effect="light">
              <el-button @click="codeEdit(scope.row)" icon="el-icon-edit" size="small"></el-button>
            </el-tooltip>
            <!--<el-tooltip content="删除" placement="top" effect="light">
              <el-button @click="codeDelete(scope.row)" icon="el-icon-delete" size="small"></el-button>
            </el-tooltip>-->
          </template>
        </el-table-column>
      </el-table>
      <!--<div class="block" >
        <el-pagination :page-sizes='[10,20,50]' :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pagedata.totalElements" @current-change="handleCurrentChange"  >
        </el-pagination>
      </div>-->

      <el-pagination
        :page-size="pagedata.size"
        layout="total, prev, pager, next, jumper"
        :total="pagedata.totalElements"
        :current-page.sync="pagedata.number"
        @current-change="handleCurrentChange">
      </el-pagination>

      <el-dialog title="新增代码表" :visible.sync="addVisible" :fullscreen="false" :close-on-click-modal="false">
        <codeAdd :codeRow="codeRow"></codeAdd>
      </el-dialog>

      <el-dialog title="查看代码表" :visible.sync="viewVisible" :fullscreen="false" :close-on-click-modal="false">
        <codeView :codeRow="codeRow"></codeView>
      </el-dialog>

      <el-dialog title="编辑代码表" :visible.sync="editVisible" :fullscreen="false" @close="query" :close-on-click-modal="false">
        <codeEdit :codeRow="codeRow"></codeEdit>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import codeView from '@/components/code/codeView.vue'
  import codeEdit from '@/components/code/codeEdit.vue'
  import codeAdd from '@/components/code/codeAdd'

  export default {
    name: 'codeList',
    components: {
      codeView,
      codeEdit,
      codeAdd
    },
    created: function () {
      this.options_flag = this.CommonUtil.getCodeList("status");
      this.$root.eventHub.$on(this.GLOBAL.COLSECODE, this.showCode);
    },
    destroyed: function () {
      this.$root.eventHub.$off(this.GLOBAL.COLSECODE);
    },
    mounted: function () {
      this.query();
    },
    data() {
      return {
        msg: 'this is codeList',
        codeRow: {},
        addVisible: false,
        viewVisible: false,
        editVisible: false,
        queryCondition: {
          type: '',
          flag: ''
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          last: true,
          size: 10,
          number: 1,
          numberOfElements: 0,
          first: true,
          sort: {}
        },
        options_flag: [],
        pageNumber: 1,
        pageSize: 10
      }
    },
    methods: {
      /**
       * TODO 功能：关闭对话框
       *
       * 参数说明:
       * 作    者:   沈 亮
       * 创建时间:   2018/9/5
       */
      showCode: function () {
        this.addVisible = false;
        this.viewVisible = false;
        this.editVisible = false;
      },
      // 翻页事件
      handleCurrentChange: function (currentPage) {
        this.pageNumber = currentPage;
        var url = '/code/codePage';
        url += '?';
        url += 'type=' + this.queryCondition.type;
        url += '&flag=' + this.queryCondition.flag;
        url += '&pageNumber=' + this.pageNumber + '&pageSize=' + this.pageSize;
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.pagedata = response.data;
          }
        })
      },
      // 查询按钮
      query: function () {
        this.pageNumber = 1;
        this.pageSize = 10;
        var url = '/code/codePage';
        url += '?type=' + this.queryCondition.type;
        url += '&flag=' + this.queryCondition.flag;
        url += '&pageNumber=' + this.pageNumber + '&pageSize=' + this.pageSize;
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.pagedata = response.data;
          }
        })
      },
      reset: function () {
        this.queryCondition = {type: '',flag: ''};
        this.query();
      },
      codeView: function (row) {
        this.codeRow = row;
        this.viewVisible = true;
      },
      codeEdit: function (row) {
        this.codeRow = row;
        this.editVisible = true;
      },
      codeAdd: function () {
        this.addVisible = true;
      },
      farmatterFlag(row) {
        return this.CommonUtil.getCodeValue("status",row.flag);
      }
    }
  }
</script>
<style scoped>
  .el-pagination {
    text-align: center;
  }
  .el-row {
    text-align: center;
  }
  .el-col-8 {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/code/codeList.vue